<template>
  <div id="app">
    <router-view></router-view>
    <div class="btm">Copyright © 2025 图灵机器人 All rights Reserved </div>
  </div>
</template>

<script>

  export default {
    data () {
      return {
      };
    }
  };
</script>

<style lang="scss" scoped="" type="text/css">
  .btm{text-align: center;font-size: 12px;color: #D3D3D3;position: fixed;left: 0;right: 0;bottom: 40px;
    @media screen and (max-height: 750px) { bottom: 10px;}
  }
</style>



// WEBPACK FOOTER //
// App.vue?3f5f0ba3